import { render, staticRenderFns } from "./DDos.vue?vue&type=template&id=753d4e63"
import script from "./DDos.vue?vue&type=script&lang=ts"
export * from "./DDos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports